/* eslint react/no-direct-mutation-state: "off", 'jsx-a11y/alt-text': 'off','no-redeclare': 'off','no-dupe-keys': 'off', 'no-loop-func':'off', eqeqeq: 'off' */
import React,{Component} from "react";
import PreventativeMaintenancelist from "./PreventativeMaintenanceList";
import { connect } from "react-redux";
import CreatePreventativeMaintenance from "./_ModalsForms/CreatePreventativeMaintenance";
import { Button, Modal } from 'reactstrap';
import { getUserPreferencesFromEquipmentSummary, getUserDetailsAfterLogin } from '../../../action/cultureAction';
import { WorkOrderRolePermission } from '../../../action/authenticateUser';
import { GetWorkOrderBuildingsEquipments, GetWorkOrderBuildings } from "../../../action/workorderAction";
import ReactDOM from "react-dom";

class WorkOrderWrapper extends Component {
    componentWillMount() {
        this.props.getUserDetailsAfterLogin();
        if (this.props.getLabels === undefined || this.props.getLabels["WorkOrders.Columns.Record.Text"] === undefined) {
            this.props.getUserPreferencesFromEquipmentSummary();
        }
        this.props.WorkOrderRolePermission(24);
        this.props.GetWorkOrderBuildings();
        this.props.GetWorkOrderBuildingsEquipments(0);
    }

    // componentDidMount(){
    //     const createButton =  document.getElementById('pm_wrapper_create_btn');
    //     createButton.addEventListener('click', () => this.toggle());
    // }

    // componentWillUnmount() {
    //     const createButton =  document.getElementById('pm_wrapper_create_btn');
    //     createButton.removeEventListener('click', () => this.toggle());
    // }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {

            var Equipment_Name = '';
            var Equipment_Id = 0;
            var Equipment_FamilyType = 0;
            var siteId = this.props.EquipmentSummary[0].BuildingID > 0 ? this.props.EquipmentSummary[0].BuildingID : window.top.location.href.split("BuildingId=")[1].split("&")[0];
            var objectId = this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0];
            var Building = (nextProps.getWorkOrderBuildings != undefined && nextProps.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false).length > 0) ? nextProps.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false) : [];
            nextProps.getBuildingEquipments.forEach(building => {
                if (building.equipment != undefined && building.equipment != null && building.equipment.length > 0) {
                    if(building.equipment.filter(x => x.objectId == objectId).length > 0)
                    {
                        Equipment_Name = building.equipment.filter(x => x.objectId == objectId)[0].objectName;
                        Equipment_Id = objectId;
                        Equipment_FamilyType = building.equipment.filter(x => x.objectId == objectId)[0].familyType;
                    }
                }
            });

            var l_BuildingId = Building.length > 0 ? Building[0].id: 0;
            var l_BuildingName = Building.length > 0 ? Building[0].name: '';

            var AlarmLog = []
            var lineItem = {
                "SiteId": l_BuildingId,
                "SiteName": l_BuildingName,
                "EquipmentId": Equipment_Id,
                "EquipmentName": Equipment_Name,
                "Description": '',
                "ActualSiteId": siteId,
                "FamilyType": Equipment_FamilyType
            }
            AlarmLog.push(lineItem);

            this.setState({AlarmInfo: AlarmLog});

        //   var modalClose = nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
        //   if (modalClose ==="close") {
        //     this.setState({ modal: false });
        //   }
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            AlarmInfo: [],
            IsBtnVisible: true
        };
        this.toggle = this.toggle.bind(this);
        // this.WrapperPopupCancel = this.WrapperPopupCancel.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });

    }
    WrapperPopupCancel = (IsSave) =>
    {
        this.setState({
            modal: false
        });    
    }

    HideCreateButton = () =>
    {
        this.setState({
            IsBtnVisible: false
        });
    }

    ShowCreateButton = () =>
    {
        this.setState({
            IsBtnVisible: true
        });
    }
    getPMComponents = () => {
        return (
            <div>
                {
                 (this.state.IsBtnVisible && this.props.UserCanEdit == 3) ? <Button type="button" id="pm_wrapper_create_btn" className="btn btn-success  TenantActionBtns workOrderButton" onClick={this.toggle}>Create Preventative Maintenance</Button> : ""
                }
                <PreventativeMaintenancelist Premise={this.props.OnPremises}  ForEquipment={true} EquipmentSummaryId={this.props.EquipmentSummary[0].EquipmentID > 0 ? this.props.EquipmentSummary[0].EquipmentID : window.top.location.href.split("EquipmentId=")[1].split("&")[0]} HideButton={this.HideCreateButton} ShowCreateButton={this.ShowCreateButton}  />
                <Modal zIndex={2147483646} isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{'z-index': '2147483647 !important'}} >
                    <CreatePreventativeMaintenance Premise={this.props.OnPremises} ForEquipment={true} OnPopupCancel={this.WrapperPopupCancel} AlarmInfo={this.state.AlarmInfo}  />
                </Modal>
            </div>
        );
    }
    render(){
        if(this.props.shouldCreatePortal){
            return ReactDOM.createPortal(this.getPMComponents(), 
            document.getElementById(this.props.portalId ? this.props.portalId : 'portal-root'))
        }else{
            return (this.getPMComponents());
        }
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        EquipmentSummary: state.authService.EquipmentSummaryDetail,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferencesFromEquipmentSummary: () => dispatch(getUserPreferencesFromEquipmentSummary()),
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuildingsEquipments: (BuildingId) => dispatch(GetWorkOrderBuildingsEquipments(BuildingId)),
        //GetPreventativeMaintenanceStandardFieldsForWrapper: () => dispatch(GetPreventativeMaintenanceStandardFieldsForWrapper()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderWrapper)

